import React, { useEffect, useState } from 'react';
import { getProcesos } from '../api';

const Dashboard = () => {
  const [metricas, setMetricas] = useState({ activos: 0, suspendidos: 0, total_candidatos: 0 });

  useEffect(() => {
    // Para simplificar, usamos getProcesos, pero en un real world habría un endpoint de /metricas
    const fetchMetricas = async () => {
      try {
        const res = await getProcesos();
        const activos = res.data.length;
        const total = res.data.reduce((add, p) => add + p.Candidatos.length, 0);
        setMetricas({ activos, suspendidos: 0, total_candidatos: total });
      } catch (err) {}
    };
    fetchMetricas();
  }, []);

  return (
    <div className="p-8 w-full max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800 uppercase tracking-wider mb-2">Visión General</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white border-t-4 border-orange-400 p-6 rounded-lg shadow-sm">
          <div className="flex flex-col items-center text-center">
            <h2 className="text-lg font-bold text-gray-700 mb-2">Métricas Generales</h2>
            <p className="text-sm text-gray-500 mb-6 px-4">
              Candidatos agregados a la base: {metricas.total_candidatos} postulantes.<br/>
              Procesos activos actualmente en el periodo.
            </p>
            <span className="text-3xl font-bold text-orange-400">{metricas.total_candidatos}</span>
          </div>
        </div>

        <div className="bg-white border-t-4 border-[#00a99d] p-6 rounded-lg shadow-sm">
          <div className="flex flex-col items-center text-center">
            <h2 className="text-lg font-bold text-gray-700 mb-2">Procesos Abiertos</h2>
            <p className="text-sm text-gray-500 mb-6 px-4">
              Procesos que estaban activos en este periodo o fueron creados recientemente.
            </p>
            <span className="text-3xl font-bold text-[#00a99d]">{metricas.activos}</span>
          </div>
        </div>

        <div className="bg-white border-t-4 border-indigo-400 p-6 rounded-lg shadow-sm">
          <div className="flex flex-col items-center text-center">
            <h2 className="text-lg font-bold text-gray-700 mb-2">Candidatos Seleccionados</h2>
            <p className="text-sm text-gray-500 mb-6 px-4">
              Exporta los reportes de las ternas finales entregadas.
            </p>
            <span className="text-3xl font-bold text-indigo-400">0</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
